import { APIClient } from "../api_helper";
import * as url from "../url_helper";

const api = new APIClient();

export const deviceRegisterAPI = data => {
    return api.create(url.DEVICE_REGISTER(data), data);
}
export const contactResearchAssistantAPI = (id, data) => {
    return api.create(url.CONTACT_RESEARCH_ASSISTANT(id), data);
}
export const contactMoreInformationAPI = (id, data) => {
    return api.put(url.CONTACT_MORE_INFORMATION(id), data);
}
export const recordActivityAPI = (id, data) => {
    return api.create(url.RECORD_ACTIVITY(id), data);
}
